import { jsxs, jsx } from 'react/jsx-runtime';
import { twMerge } from 'tailwind-merge';
import Typography from '../../Base/Typography/Typography.js';
import Box from '../../Base/Layouts/Box/Box.js';
import '../../Base/Layouts/FullBleed/FullBleed.js';

/**
 * 제목과 설명을 포함할 수 있는 리치 툴팁 컴포넌트입니다. UI만 제공하고 실제 사용은 WithRichTooltip 컴포넌트를 사용하는 것이 더 간편합니다.
 *
 * @component
 * @param {object} props - 컴포넌트 프로퍼티
 * @param {string} [props.title] - 툴팁의 제목
 * @param {string} [props.description] - 툴팁의 상세 설명
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {React.ReactNode} [props.children] - 자식 컴포넌트
 *
 * @example
 * // 기본 사용법
 * <RichTooltip
 *   title="알림"
 *   description="새로운 메시지가 도착했습니다."
 * >
 *   <button>확인</button>
 * </RichTooltip>
 *
 * // 커스텀 스타일 적용
 * <RichTooltip
 *   title="경고"
 *   description="저장되지 않은 변경사항이 있습니다."
 *   className="absolute top-0 left-0"
 * />
 */ const RichTooltip = ({ title, description, className, children })=>{
    return /*#__PURE__*/ jsxs(Box, {
        className: twMerge('flex w-full flex-col gap-1 rounded-xl bg-white px-6 py-5 shadow-graymedium tablet:w-80', className),
        "data-testid": "design-system-rich-tooltip",
        children: [
            title && /*#__PURE__*/ jsx(Box, {
                className: "flex w-full items-start justify-between gap-4",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    className: "font-medium text-w-gray-900",
                    children: title
                })
            }),
            description && /*#__PURE__*/ jsx(Typography, {
                variant: "body3",
                className: "text-w-gray-400",
                children: description
            }),
            children
        ]
    });
};

export { RichTooltip as default };
